// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (max-width:601px){.products[data-v-0758b02a]{padding:20px!important;padding-top:0!important;padding-bottom:30px!important;margin-bottom:100px}}.search[data-v-0758b02a]{width:100%;margin-bottom:50px;margin-top:15px}.grid[data-v-0758b02a]{display:grid;grid-template-columns:repeat(auto-fill,minmax(300px,1fr));gap:32px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
